<template>
    <div class="s-press__filters">
        <div v-if="appData.filters?.tags?.length" class="s-press__filters__tags">
            <div
                v-for="(item, i) in appData.filters?.tags"
                :key="'filter-tag-' + i"
                class="s-press__filters__tags__item">
                <label class="e-filter-tag" :for="'input-tag-' + item.value">
                    <input
                        :id="'input-tag-' + item.value"
                        v-model="tags.value"
                        class="e-filter-tag__input"
                        type="checkbox"
                        name="press-tags"
                        :value="item.value"
                        @change="filtersUpdated" />
                    <span class="e-filter-tag__label">{{ item.text }}</span>
                </label>
            </div>
        </div>
        <div v-if="appData.filters?.years?.length" class="s-press__filters__year">
            <select v-model="year.value" name="press-year" class="custom-select" @change="filtersUpdated">
                <option v-for="(item, i) in appData.filters?.years" :key="'filter-year-' + i" :value="item.value">
                    {{ item.text }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
import * as lib from 'Root/lib/lib.js'
import CustomSelectUI from 'Root/ui/components/CustomSelectUI.js'

export default {
    props: {},

    emits: ['filters-updated'],

    data() {
        return {
            tags: {
                key: 'tags',
                value: [],
            },
            year: {
                key: 'year',
                value: '',
            },
        }
    },

    mounted() {
        this.getUrlFilterValues()
        this.filtersUpdated()

        this.$nextTick(() => {
            this.$el.querySelectorAll('.custom-select').forEach((elem) => {
                elem.CustomSelect = new CustomSelectUI(elem)
            })
        })
    },

    methods: {
        getUrlFilterValues() {
            const urlYearValue = lib.getUrlParameter(this.year.key)
            const urlTagsValue = lib.getUrlParameter(this.tags.key)

            if (urlYearValue.length) {
                this.year.value = urlYearValue
            }
            if (urlTagsValue.length) {
                this.tags.value = urlTagsValue.split(',')
            }
        },

        setUrlFilterValues() {
            lib.setUrlParameter(this.year.key, this.year.value)
            lib.setUrlParameter(this.tags.key, this.tags.value.join(','))
        },

        filtersUpdated() {
            this.setUrlFilterValues()

            this.$emit('filters-updated', {
                tags: this.tags.value,
                year: this.year.value,
            })
        },
    },
}
</script>
